export const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const waitImmediate = () => wait(0);
